/** 内联 SVG 图标 — lucide 风格，stroke=currentColor，无第三方依赖。*/
import type { ReactNode } from 'react'

interface IconProps {
  className?: string
  strokeWidth?: number
}

function make(children: ReactNode) {
  return function Icon({ className, strokeWidth = 2 }: IconProps) {
    return (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        aria-hidden="true"
      >
        {children}
      </svg>
    )
  }
}

export const IconBack = make(
  <>
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </>,
)

export const IconChevronRight = make(<path d="M9 18l6-6-6-6" />)

export const IconRefresh = make(
  <>
    <path d="M21 12a9 9 0 1 1-2.64-6.36" />
    <path d="M21 3v6h-6" />
  </>,
)

export const IconScan = make(
  <>
    <path d="M3 7V5a2 2 0 0 1 2-2h2" />
    <path d="M17 3h2a2 2 0 0 1 2 2v2" />
    <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
    <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
    <path d="M3 12h18" />
  </>,
)

export const IconClose = make(
  <>
    <path d="M18 6L6 18" />
    <path d="M6 6l12 12" />
  </>,
)

export const IconPlus = make(
  <>
    <path d="M12 5v14" />
    <path d="M5 12h14" />
  </>,
)

export const IconSend = make(
  <>
    <path d="M12 19V5" />
    <path d="M5 12l7-7 7 7" />
  </>,
)

export const IconShare = make(
  <>
    <path d="M8 7l4-4 4 4" />
    <path d="M12 3v13" />
    <path d="M4 13v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
  </>,
)

export const IconTool = make(
  <>
    <path d="M14.7 6.3a4 4 0 0 0-5.6 5.6L3 18v3h3l6.1-6.1a4 4 0 0 0 5.6-5.6l-2.9 2.9-2-2 2.9-2.9z" />
  </>,
)

export const IconAlert = make(
  <>
    <path d="M10.3 3.7L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.7a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </>,
)

export const IconCheck = make(<path d="M20 6L9 17l-5-5" />)

export const IconMic = make(
  <>
    <path d="M12 2a3 3 0 0 0-3 3v7a3 3 0 0 0 6 0V5a3 3 0 0 0-3-3z" />
    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
    <path d="M12 19v3" />
  </>,
)

export const IconPaperclip = make(
  <path d="M21.4 11.05l-8.5 8.5a5 5 0 0 1-7.07-7.07l8.49-8.5a3.33 3.33 0 1 1 4.71 4.72l-8.49 8.49a1.67 1.67 0 0 1-2.36-2.36l7.78-7.78" />,
)

export const IconCamera = make(
  <>
    <path d="M14.5 4l1.5 2h3a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3l1.5-2z" />
    <circle cx="12" cy="13" r="3.2" />
  </>,
)

export const IconImage = make(
  <>
    <rect x="3" y="3" width="18" height="18" rx="2" />
    <circle cx="9" cy="9" r="2" />
    <path d="M21 15l-5-5L5 21" />
  </>,
)

export const IconFile = make(
  <>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <path d="M14 2v6h6" />
  </>,
)

export const IconDownload = make(
  <>
    <path d="M12 3v12" />
    <path d="M7 10l5 5 5-5" />
    <path d="M5 21h14" />
  </>,
)

export const IconKeyboard = make(
  <>
    <path d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
    <path d="M7 10h.01" />
    <path d="M11 10h.01" />
    <path d="M15 10h.01" />
    <path d="M8 14h8" />
  </>,
)
